import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import type { RouteItem } from './types'

interface State {
  token: string
  routes: RouteItem[]
  accountName: string
}

export default createStore<State>({
  state: { token: '', routes: [], accountName: '' },
  mutations: {
    SET_TOKEN(state, token: string) { state.token = token },
    SET_ROUTES(state, routes: RouteItem[]) { state.routes = routes },
    SET_ACCOUNT_NAME(state, name: string) { state.accountName = name },
    CLEAR(state) { state.token = ''; state.routes = []; state.accountName = '' }
  },
  plugins: [createPersistedState({ paths: ['token', 'routes', 'accountName'] })]
})
